import { LasDaysOverviewRowDTO, LasDaysUserDTO } from 'api/model';
import { toDateOnlyString } from 'utils/date-helpers';

// LAS-dagarnas datum är kalenderdagar som backend skickar som "ÅÅÅÅ-MM-DD"-strängar. Men
// handleDates() i Orval-mutatorn gör om varje sådan sträng i svaret till ett Date, även fält
// som är deklarerade som string, så att rendera dem direkt kraschar sidan ("Objects are not
// valid as a React child"). Här görs de om till strängar igen, en gång, så att rendering,
// sortering och dagnumren i månadsvyn kan lita på typerna.

const toDay = (value: string | undefined) =>
  value ? toDateOnlyString(value) : undefined;

export const normalizeLasDaysRow = (
  r: LasDaysOverviewRowDTO
): LasDaysOverviewRowDTO => ({
  ...r,
  firstWorkedDate: toDateOnlyString(r.firstWorkedDate),
  lastWorkedDate: toDateOnlyString(r.lastWorkedDate),
  thresholdReachedDate: toDay(r.thresholdReachedDate),
});

export const normalizeLasDaysUser = (u: LasDaysUserDTO): LasDaysUserDTO => ({
  ...u,
  thresholdReachedDate: toDay(u.thresholdReachedDate),
  months: u.months.map((m) => ({
    ...m,
    firstWorkedDate: toDateOnlyString(m.firstWorkedDate),
    lastWorkedDate: toDateOnlyString(m.lastWorkedDate),
    workedDates: m.workedDates.map((d) => toDateOnlyString(d)),
  })),
});
